import {
    Text,
} from "@chakra-ui/react";

import Card from "./Card";

const MiniStatCard = ({
    title,
    value,
}) => {
    return (
        <Card p={5}>
            <Text
                fontSize="11px"
                fontWeight="700"
                color="gray.500"
                textTransform="uppercase"
                letterSpacing="1px"
            >
                {title}
            </Text>

            <Text
                mt={3}
                fontSize="27px"
                fontWeight="700"
                color="#071D54"
                lineHeight="1"
            >
                {value}
            </Text>
        </Card>
    );
};

export default MiniStatCard;